import { render, staticRenderFns } from "./rankingBoard.vue?vue&type=template&id=15ff43e6"
import script from "./rankingBoard.vue?vue&type=script&lang=js"
export * from "./rankingBoard.vue?vue&type=script&lang=js"
import style0 from "./rankingBoard.vue?vue&type=style&index=0&id=15ff43e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports